import { useQuery, useQueryClient } from '@tanstack/react-query';
import { IonToggle } from '@ionic/react';
import { Card, Spinner } from '@tcrd/ui';
import { Page } from '../../components/Page';
import { ServiceIcon } from '../../components/ServiceIcon';
import { useToast } from '../../components/toast';
import { api, errorMessage } from '../../lib/api';

interface ServiceRow {
  id: string;
  name: string;
  description: string | null;
  icon: string | null;
  enabled: boolean;
}

export function ServicesPage() {
  const qc = useQueryClient();
  const toast = useToast();
  const q = useQuery({ queryKey: ['services-manage'], queryFn: () => api<ServiceRow[]>('/services/manage') });

  const toggle = async (s: ServiceRow, enabled: boolean) => {
    try {
      await api(`/services/${s.id}`, { method: 'PATCH', body: { enabled } });
      await qc.invalidateQueries({ queryKey: ['services-manage'] });
      await qc.invalidateQueries({ queryKey: ['public-profile'] });
      toast(enabled ? `${s.name} habilitado` : `${s.name} deshabilitado`);
    } catch (e) {
      toast(errorMessage(e), 'danger');
    }
  };

  return (
    <Page title="Servicios" back="/driver/more">
      <p className="text-sm text-[var(--text-muted)] mb-4">Los servicios deshabilitados no aparecen en la página pública ni al solicitar viajes.</p>
      {q.isLoading ? (
        <Spinner />
      ) : (
        <Card className="divide-y divide-[var(--border)]">
          {q.data?.map((s) => (
            <div key={s.id} className="flex items-center gap-3 px-4 py-3">
              <ServiceIcon name={s.icon} className="size-5 text-[var(--text-muted)]" />
              <div className="flex-1 min-w-0">
                <p className="font-medium">{s.name}</p>
                {s.description && <p className="text-xs text-[var(--text-muted)] truncate">{s.description}</p>}
              </div>
              <IonToggle checked={s.enabled} onIonChange={(e) => void toggle(s, e.detail.checked)} aria-label={`Habilitar ${s.name}`} color="danger" />
            </div>
          ))}
        </Card>
      )}
    </Page>
  );
}
